import { Component, HostListener, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToggleClassService } from '../../../service/toggle/toggle-class.service';
import { SharedModule } from '../../../shared/shared.module';

@Component({
  standalone: true,
  selector: 'app-dashboard-layout',
  templateUrl: './dashboard-layout.component.html',
  styleUrls: ['./dashboard-layout.component.scss'],
  imports: [RouterOutlet, SharedModule]
})
export class DashboardLayoutComponent implements OnInit {

   isMobile:boolean
   
   public constructor(public toggleService: ToggleClassService) {

  }
  ngOnInit(): void {
    this.mostrarMenu()
  }


  mostrarMenu(){
    //mido el contenedor
    let widthContent = document.documentElement.clientWidth;

    if (widthContent <= 640) {
      this.isMobile = true
      this.toggleService.comprimida = true
    }
    else {
      this.isMobile = false
      this.toggleService.comprimida = false
    }
    
  }

  @HostListener('window:resize', ['$event'])
  onResize($event) {
    this.mostrarMenu();
  }
  // @HostListener('window:resize', ['$event'])
  // onWindowResize(event) {
  //   event.target.innerWidth ? (this.toggleService.comprimida = true) : ( this.toggleService.comprimida = false )
  // }

}
